export default __webpack_public_path__ + "static/media/identify-learning-styles.f13eef76.svg";